import request from 'superagent'
import { createAction } from 'redux-actions'

/**
 * Action types.
 */

export const REQUEST_USERS_BY_WORKSPACE_SLUG = 'REQUEST_USERS_BY_WORKSPACE_SLUG'
export const REQUEST_USERS_BY_WORKSPACE_SLUG_ERROR = 'REQUEST_USERS_BY_WORKSPACE_SLUG_ERROR'
export const RECEIVE_USERS_BY_WORKSPACE_SLUG = 'RECEIVE_USERS_BY_WORKSPACE_SLUG'

/**
 * Actions.
 */

const requestUsersByWorkspaceSlug = createAction(REQUEST_USERS_BY_WORKSPACE_SLUG)
const requestUsersByWorkspaceSlugError = createAction(REQUEST_USERS_BY_WORKSPACE_SLUG_ERROR)
const receiveUsersByWorkspaceSlug = createAction(RECEIVE_USERS_BY_WORKSPACE_SLUG)

export function fetchUsersByWorkspaceSlug (slug) {
  return (dispatch) => {
    dispatch(requestUsersByWorkspaceSlug({ slug }))

    return request
    .get(`/api/workspaces/${slug}/owners`)
    .end(function (err, res) {
      if (err || !res.ok) {
        const error = err || new Error(`Unable to fetch owners for workspace "${slug}": ${res.status}`)
        dispatch(requestUsersByWorkspaceSlugError({ slug, error }))
      } else {
        dispatch(receiveUsersByWorkspaceSlug({ slug, data: res.body }))
      }
    })
  }
}



// WEBPACK FOOTER //
// ./actions/users.js